// extracted by mini-css-extract-plugin
export const loadingWrapper = "ChartLoading-module__loading-wrapper--4q9Ax";